import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = signed out

  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (_) {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    // Skip while returning from Google OAuth; AuthCallback establishes the session first.
    if (window.location.hash?.includes("session_id=")) {
      setUser(false);
      return;
    }
    check();
  }, [check]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, setUser, logout, check }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
